import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import NewIssueForm from 'Component/NewIssueForm';
import Popup from 'Component/Popup';
import { OrderType } from 'Type/Order.type';

import { CLIENT_ISSUE_POPUP_ID } from './NewIssuePopup.config';

import './NewIssuePopup.style';

/** @namespace PeggysagePwa/Component/NewIssuePopup/Component */
export class NewIssuePopupComponent extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            title: PropTypes.string,
            order: OrderType
        }).isRequired
    };

    renderContent() {
        const { payload: { order } } = this.props;

        return (
            <NewIssueForm order={ order } />
        );
    }

    render() {
        const { payload: { title } } = this.props;

        return (
            <Popup
              id={ CLIENT_ISSUE_POPUP_ID }
              isCloseOnOutsideClick={ false }
              title={ title }
              mix={ { block: 'NewIssuePopup' } }
            >
                { this.renderContent() }
            </Popup>
        );
    }
}

export default NewIssuePopupComponent;
